import { useEffect, useState, useContext } from 'react';
import  TextField  from '@mui/material/TextField';
import Storage from '../../../session/storage';
import Autocomplete from '@mui/material/Autocomplete';
import CONSTANT from '../../../Constant/Constant';
import { sortTranslated } from '../../shared/util';
import { DropdownContext } from '../../../context/DropDownContext';
import { UiPicklistContext } from '../../../context/UiPicklistContext';
import profileData from '../../../config/ProfileDetailsData.json';

const InputDetailsHCO = (props) => {
    const [value, setValue] = useState(props.value || null)
    const [lengthFlag, setFlag] = useState();
    const [label] = useState(props.label);
    const [invalidInputFlag , setInvalidInputFlag ] = useState(false)
    const [mainInfoData] = useState(props?.newValue?.find((el) => {
        return el.id === 'mainInfo'
    }));
    const [contactdata ] = useState(props?.newValue?.find((el) => {
        return el.id === 'contactData'
    }));
    const { dropdownvalue } = useContext(DropdownContext);
    const { uiDropdownValue } = useContext(UiPicklistContext);
    const sourceData  = profileData
    let option;

    /**
     * map name to key
     * @param {*} name name of attribute
     * @returns key name of attribute
     */
    const getOptionKey = (name) => {
        switch (name) {
            case 'Classification Code':
                return 'Classification';
            case 'Sub Classification Code':
                return 'SubClassification';
            case 'Prefix':
                return 'Title';
            case 'Other Specialty':
                return 'Specialty';
            case 'Primary Specialty':
                return 'Specialty';
            case 'Specialty Type':
                return 'SpecialtyType';
        case 'Identifiers Type':
                return 'AltIDType';
            case 'Identifiers Sub Type':
                return 'AltIDSubtype';                   
            case 'Country':
                return 'Country';     
            case 'Country Code':
                return 'Country';
            case 'State Province':
                return 'StateProvince';
            case 'Relationship Type Code':
                return 'RelationshipType';
            default:
                return name;

                
        }
    };

    // const  onlyUnique = (value, index, array) => {
    //     return (array.indexOf(value) === index)
    //   };
      

    /**
     * Map name to ID
     * @param {*} name 
     * @returns ID of atrribute
     */
    const getId = (name) => {
        switch (name) {
            case 'Classification Code':
                return 'ClassificationCode';
            case 'Sub Classification Code':
                return 'SubClassificationCode';
            case 'Name':
                return 'Name';
            case 'Middle Name':
                return 'MiddleName';
            case 'Primary Specialty':
                return 'PrimarySpecialty';
            case 'Other Specialty':
                return 'OtherSpecialty';
            case 'Identifiers Type':
                return 'Type';
            case 'Identifiers Sub Type':
                return 'SubType'; 
            case 'Country Code':
                return 'Country';
            case 'State Province':
                return 'StateProvince';
            case 'Country':
                return 'Country';
            case 'Relationship Type Code':
                return 'RelationshipType ';     

            default:
                return name;
        }
    };

    let options = (sourceData.OPEN_DATA_SOURCES.includes(props.sourceName) ? CONSTANT.LOV_BOUNDED_OPTION_SPCIAL_CASE.includes(getId(label.trim())) :  CONSTANT.LOV_BOUNDED_OPTION.includes(getId(label.trim()))) ? Storage.getLovBoundedList() : Storage.getPickList()['HCO'];
    options = CONSTANT.FORCED_OPTION.includes(label.trim()) ? {HCO:{[label.trim()]: CONSTANT.FORCED_OPTION_VALUE[label.trim()] }} : options;
    if(label !== "Country Code" && label !== "Relationship Type Code"){
        if(props.sourceName !== undefined && sourceData.OPEN_DATA_SOURCES.includes(props.sourceName)){
            option = CONSTANT.STASTIC_ATTRIBUTE_HCO_exclusion.includes(label.trim()) ? undefined :options?.HCO[getOptionKey(label?.trim())]
        }else{
            option = CONSTANT.STASTIC_ATTRIBUTE_HCO.includes(label.trim()) ? undefined :options?.HCO[getOptionKey(label?.trim())]
        }
    }
    else{
        option = CONSTANT.STASTIC_ATTRIBUTE_HCO.includes(label.trim()) ? undefined :options[getOptionKey(label?.trim())]
        if(label === "Relationship Type Code"){
            option = option[props?.source]
        }
    }

    // const unique_option = option?.filter(onlyUnique)
    const [required, setRequired] = useState();

    useEffect(() => {
           if(dropdownvalue === undefined || dropdownvalue === null || dropdownvalue.length === 0) return;
            options = CONSTANT.LOV_BOUNDED_OPTION.includes(getId(label.trim())) ? dropdownvalue : uiDropdownValue['HCO'];
            options = CONSTANT.FORCED_OPTION.includes(label.trim()) ? {HCO:{[label.trim()]: CONSTANT.FORCED_OPTION_VALUE[label.trim()] }} : options;
            if(label !== "Country Code" && label !== "Relationship Type Code"){
                option = CONSTANT.STASTIC_ATTRIBUTE_HCO.includes(label.trim()) ? undefined :options?.HCO[getOptionKey(label?.trim())]
            }
            else{
                option = CONSTANT.STASTIC_ATTRIBUTE_HCO.includes(label.trim()) ? undefined :options[getOptionKey(label?.trim())]
                if(label === "Relationship Type Code"){
                    option = option[props?.source]
                }
            }
    },[dropdownvalue])
    

    /**
     * Pass value to parent
     * @param {*} event 
     */
    const passToParent = async (event) => {
        setFlag(event.target.value === null || (event.target.value !== null && event.target.value.length === 0));
        await setValue(event.target.value)
        props.updatedValue({ value: event.target.value === null ? '' : event.target.value }, required && (event.target.value === null || (event.target.value !== null && event.target.value.length === 0)))
    }

    /**
     * Handel Input Change
     * @param {*} event : event
     * @param {*} passTo : parent flag
     * @param {*} reqFlag : validation flag
     */
    const handelInput = (event, passTo, reqFlag) => {

        mainInfoData?.attributes?.map((el)=>{
          
            if(event.target.name === el.name && el.pattern){

               
                if(event.target.value.match(el.pattern.includes('+') ? el.pattern.replace('+',"\\s") : el.pattern )){
               
                    setInvalidInputFlag(false)
                }
                else{
                   
                    setInvalidInputFlag(true)
                    
                }
            }
            return({})

        })

       contactdata?.attributes?.map((el)=>{
          
        if(event.target.name === el.name && (el.pattern)){
            
            if(event.target.value.match(el.pattern)){
          
                setInvalidInputFlag(false)
            }
            else{
                
                setInvalidInputFlag(true)
                
            }
        }
        return({})

    })

        
        setFlag(event.target.value === null || (event.target.value !== null && event.target.value.length === 0))
        setValue(event.target.value)

        if (passTo) {
            passToParent(event)
        }
    }

    useEffect(() => {
        let flag = (value === null) || (value !== undefined && value.length === 0);
        flag = (props.error && flag)
        setFlag(flag);
       // setRequired(props.newHCO !== undefined ? CONSTANT.REQUIRED_HCP.includes(label.trim()) : !CONSTANT.OPTIONAL.includes(getId(label.trim())))
        setRequired(props.newHCO !== undefined ? props.require: false)
       
        
        if (props.clear && option === undefined) {
            setValue('')
        } else if (props.clear && option !== undefined) {
            setValue(null)
        }
    }, [props.clear, option, props.error, value, label, props.newHCO, props.require])

    useEffect(()=>{
        if(label === "Relationship Type Code"){
            setValue(null)
        }
    },[props.isParent])

    return (
        <>
        {
            props.date === false && option !== undefined &&  !['Country Code','Relationship Type Code', 'State Province'].includes(label) &&
                <Autocomplete
                    value={(label.trim() === 'Other Specialty' && value === null) ? [] : value}
                    key={label}
                    onChange={(event, value) => 
                    handelInput({
                        target: { 
                            value: label.trim() === 'Other Specialty' 
                            ? value.length > 0 
                            ? value.map(res => res.split('//')[0]) 
                            : value 
                            : value?.split('//')[0].length > 0 
                            ? value.split('//')[0] 
                            : value 
                            }
                    }, true)}                      
                    options={option.flatMap(group => sortTranslated(group.options))}
                    getOptionLabel={(option) => option.split('//')[0]}   
                    groupBy={(option) => {return option?.includes('//UnClassified') ? 'Unclassified' :`HCO - ${label}` }}
                    id={label}
                    name={label}
                    multiple={label.trim() === 'Other Specialty'}
                    renderInput={(params) =>
                        <TextField {...params} error={(lengthFlag) && required}
                        helperText={((lengthFlag) && required) ? "Please Select One Option" : " "}
                        variant ="standard" id="varantOptionTxT"/>}
                    />
        }
        {                           
            props.date === false && option !== undefined && ['Country Code'].includes(label) &&
            <Autocomplete
                value={(label.trim() === 'Other Specialty' && value === null) ? [] : value}
                key={label}                    
                onChange={(event, value) => handelInput({ target: { value: value } }, true)}
                options={sortTranslated(option)}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                id={label}
                name={label}
                multiple={label.trim() === 'Other Specialty'}
                renderInput={(params) =>
                    <TextField {...params} error={(lengthFlag) && required}
                        variant="standard"  
                        id="varantOptionTxT"                    
                        helperText={((lengthFlag) && required) ? "Please Select One Option" : " "} />}
                />
        }
        {                           
            props.date === false && option !== undefined && ['State Province'].includes(label) &&
            <Autocomplete
                value={(label.trim() === 'Other Specialty' && value === null) ? [] : value}
                key={label}                    
                onChange={(event, value) => handelInput({ target: { value: value?.split(" | ")[0] } }, true)}
                options={sortTranslated(option)}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                id={label}
                name={label}
                multiple={label.trim() === 'Other Specialty'}
                renderInput={(params) =>
                    <TextField {...params} error={(lengthFlag) && required}
                        variant="standard"  
                        id="varantOptionTxT"                    
                        helperText={((lengthFlag) && required) ? "Please Select One Option" : " "} />}
                />
        }
            {/* {
                props.date === false && option !== undefined &&
                <Autocomplete
                    value={(label.trim() === 'Other Specialty' && value === null) ? [] : value}
                    key={label}
                    onChange={(event, value) => handelInput({ target: { value: label.trim() === 'Other Specialty' ? value.map((res)=> res.split('//')[0]) : value }}, true)}
                    options={option.flatMap(group => group.options)}
                    getOptionLabel={(option) => option.split('//')[0]}
                    groupBy={(option) => {return option.includes('//UnClassified') ? 'Unclassified' :`HCO - ${label} ` }}
                    id={label}
                    name={label}
                    multiple={label.trim() === 'Other Specialty'}
                    renderInput={(params) =>
                        <TextField {...params} error={(lengthFlag) && required}
                            helperText={((lengthFlag) && required) ? "Please Select One Option" : " "}
                            variant ="standard" id="varantOptionTxT"/>}
                />
            } */}
            {
                props.date === true && props.type !== 'number' && option === undefined &&
                <TextField
                    variant="standard"
                    value={value || ''}
                    id={label}
                    name={label}
                    onChange={handelInput}
                    error={(lengthFlag) && required }
                    helperText={((lengthFlag) && required ) ?  <span id="input-text">Please Enter Valid Input</span> : " "}
                    onBlur={passToParent}
                    className="w-100 input-text"
                    type="date"
                    inputProps={{ max: "9999-12-31" }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            }
            {
                props.date === false && option === undefined &&
                < TextField
                    type={props.type}
                    key={label}
                    error={(lengthFlag && required) || invalidInputFlag}
                    helperText={((lengthFlag && required) || invalidInputFlag) ? <span id="input-text">Please Enter Valid Input</span> : " "}
                    value={(value || '')}
                    onChange={handelInput}
                    onBlur={passToParent}
                    id={label}
                    name={label}
                    variant ="standard"
                    color="primary" className="w-100 input-text" />
            }
            {
                props.virtualHCO === true && props.date === false && option !== undefined && label === "Relationship Type Code" &&
                <Autocomplete
                    value={value}
                    key={label}                    
                    onChange={(event, value) => handelInput({ target: { value: value } }, true)}
                    options={option.sort((a, b) => (a > b) ? 1 : -1).filter((item, index, array) => array.indexOf(item) === index)}
                    id={label}
                    name={label}
                    renderInput={(params) =>
                        <TextField {...params} error={(lengthFlag) && required}
                            variant="standard"  
                            id="varantOptionTxT"                    
                            helperText={((lengthFlag) && required) ? "Please Select One Option" : " "} />}
                />
            }
        </>
    )

}

export default InputDetailsHCO;